import React, { useState, useRef, useEffect } from "react";
import { connect } from "react-redux";
import { useSnackbar } from "notistack";
import NumberFormat from "react-number-format";

import { RootState } from "../../models/RootState";
import { BsData } from "../../models/BsData";
import {
  removeExchangeBet,
  setExchangeBetStake,
  clearExchcngeBets,
  exchangeBetOddsChange,
  fetchOpenBets,
  fetchBalance,
  setBetSlipOddsChangeMsg,
  acceptOddsChange,
} from "../../store";
import API from "../../services";
import { USER_API } from "../../services";
import { MarketNamesMap } from "../../constants/common-utlits";
import "./PremiumFancyBetslip.scss";
import { setTextColor } from "../../store/auth/authActions";

type StoreProps = {
  bets: BsData[];
  setExchangeBetStake: (
    index: number,
    amount: number,
    type: "ADD" | "SET"
  ) => void;
  setBetSlipOddsChangeMsg: (value: boolean) => void;
  exchangeBetOddsChange: (index: number, odds: number) => void;
  removeExchangeBet: (index: number) => void;
  clearExchangeBets: () => void;
  fetchOpenBets: (eventId, sportId) => void;
  fetchBalance: Function;
  acceptOddsChange: () => void;
  page: string;
  enqueueSnackbar?: any;
  oddsChanged: boolean;
  betSuspended: boolean;
  betSlipMessage: string;
  userBalance: number;
  minStake: number;
  maxStake: number;
  currency: string;
};

const PremiumFancyBetslip: React.FC<StoreProps> = (props) => {
  const {
    bets,
    setExchangeBetStake,
    removeExchangeBet,
    clearExchangeBets,
    exchangeBetOddsChange,
    fetchOpenBets,
    acceptOddsChange,
    fetchBalance,
    oddsChanged,
    betSuspended,
    betSlipMessage,
    page,
    userBalance,
    currency,
    minStake,
    maxStake
  } = props;

  const [loading, setLoading] = useState(false);
  // const [stackFocus, setStackFocus] = useState(true);
  const { enqueueSnackbar } = useSnackbar();
  let providerId = sessionStorage.getItem("psProviderId");
  let operatorId = sessionStorage.getItem("psOperatorId");
  const stakeAmountList = [100, 200, 500, 1000, 2000, 5000];
  const stakeKeyBoardValues = [
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "0",
  ];

  const isMounted = useRef(true);

  const pollingCancelled = useRef(false);

  useEffect(() => {

      isMounted.current = true;
      pollingCancelled.current = false;

      return () => {

          isMounted.current = false;
          pollingCancelled.current = true;

      };

  }, []);

  const sleep = (ms: number) =>
    new Promise(resolve => setTimeout(resolve, ms));

  const placeBet = async (data: BsData) => {
    console.log("dataa", data);

    if (data?.stakeAmount < 0) {
      return enqueueSnackbar("Invalid stake amount.", {
        variant: "error",
      });
    }

    try {
      if (isMounted.current) {
        setLoading(true);
      }
      const payload = {
        token: sessionStorage.getItem("psAuthToken"),
        partnerId: sessionStorage.getItem("psPartnerId"),
        operatorId: operatorId,
        providerId: sessionStorage.getItem("psProviderId"),
        sportId: data.sportId,
        competitionId: data.competitionId,
        eventId: data.eventId,
        betType: data.betType,
        oddValue: data.oddValue,
        stakeAmount: data?.stakeAmount,
        marketType: data.marketType
          ? data.marketType
          : MarketNamesMap(data.marketName.replace(/\s/g, "")),
        marketName: data.marketName,
        marketId: data.marketId,
        runnerId: data.runnerId,
        runnerName: data.runnerName,
        origin: sessionStorage.getItem("lobbyType"),
        sessionOutcome: data.sessionOutcome ? data.sessionOutcome : null,
      };

      const res: any = await API.post("/sportsbet", payload);
      if (res.data.status === "") {
        if (isMounted.current) {
          setLoading(false);
        }

        return enqueueSnackbar(res.data?.errorDescription, {
          variant: "error",
          anchorOrigin: {
            vertical: "top",
            horizontal: "center",
          },
        });
      } else if (res.data.status === "RS_OK") {
        if (res.data.betId && !res.data.errorDescription) {
            return getBetStatus(data, res.data.betId);
        } else {
          if (isMounted.current) {
            setLoading(false);
          }
          return enqueueSnackbar(res.data?.errorDescription, {
            variant: "success",
            autoHideDuration: 2000,
            anchorOrigin: {
              vertical: "top",
              horizontal: "center",
            },
          });
        }
      }
    } catch (e) {
      if (isMounted.current) {
        setLoading(false);
      }
      return enqueueSnackbar("Something went wrong, try again", {
        variant: "error",
        anchorOrigin: {
          vertical: "top",
          horizontal: "center",
        },
      });
    }
  };

  const getBetStatus = async (data: BsData, betId: string) => {

      if (isMounted.current) {
          setLoading(true);
      }

      const payload = {
        betId: betId,
        eventId: data.eventId,
        partnerId: sessionStorage.getItem("psPartnerId"),
        operatorId,
        providerId: sessionStorage.getItem("psProviderId"),
        sportId: data.sportId,

        token: sessionStorage.getItem("user_api_token"),
        competitionId: data.competitionId,
        betType: data.betType,
        oddValue: data.oddValue,
        stakeAmount: data?.stakeAmount,
        marketType: data.marketType
          ? data.marketType
          : MarketNamesMap(data.marketName.replace(/\s/g, "")),
        marketName: data.marketName,
        marketId: data.marketId,
        runnerId: data.runnerId,
        runnerName: data.runnerName,
        origin: sessionStorage.getItem("lobbyType"),
        sessionOutcome: data.sessionOutcome ? data.sessionOutcome : null,
      };

      const started = Date.now();

      const MAX_WAIT = 30000;

      while (!pollingCancelled.current) {

          try {

              const res: any = await USER_API.post("/userbet-status", payload);

              if (!isMounted.current || pollingCancelled.current) {
                  return;
              }
              const status = res.data.betStatus;

              if (status === "BETTING_IN_PROGRESS" || status === "PENDING") {

                  if (Date.now() - started > MAX_WAIT) {

                      if (isMounted.current) {

                          setLoading(false);

                          enqueueSnackbar("Bet confirmation timeout.", {
                              variant: "warning",
                          });

                      }

                      return;
                  }

                  await sleep(500);
                  if (!isMounted.current || pollingCancelled.current) {
                    return;
                  }
                  continue;
              }

              if (
                  res.data.status === "RS_OK" &&
                  ["FAILED", "EXPIRED", "CANCELLED"].includes(status)
              ) {

                  if (isMounted.current) {

                      setLoading(false);

                      const errorMessage =
                          res.data?.betErrorMsg ||
                          res.data?.errorDescription ||
                          res.data?.message ||
                          "Bet is not placed, try again";

                      enqueueSnackbar(errorMessage, {
                          variant: "error",
                          anchorOrigin: {
                              vertical: "top",
                              horizontal: "center",
                          },
                      });

                  }

                  return;
              }

              if (status === "OPEN") {

                  if (isMounted.current) {

                      setLoading(false);

                      clearExchangeBets();

                      featchOpenBets(data.eventId, data.sportId);

                      enqueueSnackbar(
                          res.data.errorDescription ??
                          "Bet placed successfully.",
                          {
                              variant: "success",
                              autoHideDuration: 2000,
                          }
                      );

                  }

                  return;
              }

              await sleep(500);

          } catch (err: any) {

              console.error("Bet status check failed:", err);

              if (isMounted.current) {

                  setLoading(false);

                  // USER_API can reject the request for non-2xx responses.
                  // In that case the provider response is available under
                  // err.response.data.
                  const errorData = err?.response?.data ?? err?.data ?? {};

                  const errorMessage =
                      errorData?.betErrorMsg ||
                      errorData?.errorDescription ||
                      errorData?.message ||
                      err?.response?.statusText ||
                      err?.message ||
                      "Unable to check bet status.";

                  enqueueSnackbar(errorMessage, {
                      variant: "error",
                      anchorOrigin: {
                          vertical: "top",
                          horizontal: "center",
                      },
                  });
              }

              return;
          }

      }

  };

  const featchOpenBets = (eventId: string, sportId: string) => {
    fetchOpenBets(eventId, sportId);
    fetchBalance();
  };

  const oddsChange = (index, val) => {
    if (val) exchangeBetOddsChange(index, parseFloat(val.toString()));
  };

  const onStakeChangeHandler = (stake: number) => {
    setExchangeBetStake(0, stake, "SET");
  };

  const onAddStakeChangeHandler = (exstingStake: number, stake: string) => {
    var amount = exstingStake.toString() + stake;
    setExchangeBetStake(0, +amount, "SET");
  };

  const onBackSpaceHandler = (value: number) => {
    setExchangeBetStake(0, Math.floor(value / 10), "SET");
  };

  const onStakeChangeIconHandler = (exstingStake: number, falg: number) => {
    if (falg) {
      setExchangeBetStake(0, exstingStake + 1, "SET");
    } else {
      exstingStake === 0
        ? setExchangeBetStake(0, 0, "SET")
        : setExchangeBetStake(0, exstingStake - 1, "SET");
    }
  };

  return (
    <>
      {bets && bets.length > 0
        ? bets.map((bet, index) => {
            return (
              <div
                  key={`${bet.marketId}-${bet.runnerId}`}
                  className="pf-betslip"
              >
                {loading ? (
                  <div className="loading-overlay bet-slip-loading" id="loading">
                    <div className="loading-wrap" style={{ display: "flex" }}>
                      <div className="loading">
                        <div />
                        <div />
                      </div>
                      <p>Loading...</p>
                    </div>
                  </div>
                ) : null}
                <div className="mob-view">
                  <div
                    id="betBoard_2_2209550_172228836_1853582993"
                    className="premium-betslip bet_slip-wrap back"
                    style={{ display: "block" }}
                  >
                    <div
                      id="messageWrap"
                      className="message-wrap"
                      style={{ display: "none" }}
                    >
                      <div className="message">
                        <h4 id="header">The Minimun stake is $25.00</h4>
                        <p id="info">
                          Your stake has been updated accordingly.
                        </p>
                      </div>
                      <span
                        id="close"
                        className="close"
                        onClick={() => clearExchcngeBets()}
                      >
                        Close
                      </span>
                    </div>

                    <ul
                      className="btn-list bts-header"
                      style={{ marginBottom: "-15px" }}
                    >
                      <li>
                        {/* <p
                          className="dynamic-min-bet"
                          style={{ marginTop: "3px", height: "8px" }}
                        >
                          &nbsp;
                        </p> */}
                        <div
                          id="inputOdds"
                          className="input-num odds-input disable"
                        >
                          {/* <span
                          id="oddsDown"
                          className="icon-minus"
                          style={{ display: "none" }}
                        /> */}
                          <div id="odds" className="odds">
                            {bet.oddValue.toFixed(2)}
                          </div>
                          {/* <span
                          id="oddsUp"
                          className="icon-plus"
                          style={{ display: "none" }}
                        /> */}
                        </div>
                      </li>
                      <li>
                        {/* <p
                          className="dynamic-min-bet"
                          style={{ marginTop: "3px", height: "8px" }}
                        >
                          Min Bet: <strong id="dynamicMinBet" />
                        </p> */}
                        <div id="inputStake" className="input-num stake-input">
                          <a
                            onClick={() =>
                              onStakeChangeIconHandler(bet.stakeAmount, 0)
                            }
                            id="stakeDown"
                            className="icon-minus"
                          />
                          <span id="stake" className="stake typeing">
                            {bet.stakeAmount}
                          </span>
                          <a
                            onClick={() =>
                              onStakeChangeIconHandler(bet.stakeAmount, 1)
                            }
                            id="stakeUp"
                            className="icon-plus"
                          />
                        </div>
                      </li>
                    </ul>

                    <ul
                      id="stakePopupList"
                      style={{ marginBottom: "10px" }}
                      className="coin-list"
                    >
                      {stakeAmountList.map((amount: number, idx: number) => (
                         <li key={amount}>
                          <span
                            id={`stake-keyboard-${idx}`}
                            className="def-stake-amt"
                            onClick={() =>
                              setExchangeBetStake(0, amount, "ADD")}
                          >
                            {amount}
                          </span>
                        </li>
                      ))}
                    </ul>

                    <div id="keyboard" className="keyboard-wrap">
                      <ul id="numPad" className="btn-tel">
                        {stakeKeyBoardValues.map((value, idx) => (
                           <li key={`keyboard-${value}-${idx}`}>
                            <span
                              className="keyboard-btn"
                              onClick={() =>
                                onAddStakeChangeHandler(bet.stakeAmount, value)
                              }
                            >
                              {value}
                            </span>
                          </li>
                        ))}
                      </ul>
                      <span
                        id="delete"
                        onClick={() => onBackSpaceHandler(bet.stakeAmount)}
                        className="btn-delete keyboard-btn"
                      />
                    </div>
                    <ul
                      className="betslip-btns"
                    >
                      <div className="min-stake-btn betslip-btn" onClick={() => setExchangeBetStake(0, minStake, "SET")}>
                        MIN STAKE
                      </div>
                      <div className="max-stake-btn betslip-btn" onClick={() => setExchangeBetStake(0, maxStake, "SET")}>
                        MAX STAKE
                      </div>
                      <div className="clear-btn betslip-btn" onClick={() => setExchangeBetStake(0, 0, "SET")}>
                        CLEAR
                      </div>
                    </ul>
                    <ul
                      className=" bts-footer betslip-main-btns"
                      style={{ marginBottom: "-1px" }}
                    >
                        <div
                          id="cancel"
                          className="btn"
                          onClick={() => {

                            pollingCancelled.current = true;

                            clearExchangeBets();

                          }}
                        >
                          Cancel
                        </div>
                        <div
                          id="placeBet"
                          className={`btn-send disable ${setTextColor(getComputedStyle(document.body).getPropertyValue('--primary'))}`}
                          // disabled={
                          //   loading ||
                          //   oddsChanged ||
                          //   betSuspended ||
                          //   isNaN(bet?.stakeAmount) ||
                          //   bet?.stakeAmount === 0
                          // }
                          onClick={() => {
                            placeBet(bet);
                          }}
                        >
                          Place Bet
                        </div>
                    </ul>
                    {/* <div
                      id="acceptAnyOddsBox"
                      className="bet-setting"
                      style={{ display: "flex" }}
                    >
                      <span id="acceptAnyOdds" className="bet-check checked">
                        Accept Any Odds
                      </span>
                      <span id="sportsBookMaxStake" style={{}}>
                        <span id="getSportsBookMaxStakeBtn" className="max-bet">
                          Max
                        </span>
                      </span>
                    </div> */}
                  </div>
                </div>

                <>
                  {/* desktopview */}
                    <div className="fancy-container">
                      <div
                        id="fancy-premium"
                        className="fancy-quick-tr desk-view"
                        style={{ display: "grid" }}
                      >
                        <div className="table-class">
                          <dl className="quick_bet-wrap slip-book">

                            <dt id="sportsBookBetHeader" className="">
                              <div id="sportsBookMaxStake" className="max-bet">
                                <a
                                  id="getSportsBookMaxStakeBtn"
                                  href="#"
                                  className="max-stake-btn"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    setExchangeBetStake(0, maxStake, "SET");
                                  }}
                                >
                                  Max
                                </a>
                              </div>

                              <div id="sportsBookMaxStake" className="max-bet">
                                <a
                                  id="getSportsBookMaxStakeBtn"
                                  href="#"
                                  className="min-stake-btn"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    setExchangeBetStake(0, minStake, "SET");
                                  }}
                                >
                                  Min
                                </a>
                              </div>

                              <div id="sportsBookMaxStake" className="max-bet">
                                <a
                                  id="getSportsBookMaxStakeBtn"
                                  href="#"
                                  className="clear-btn"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    setExchangeBetStake(0, 0, "SET");
                                  }}
                                >
                                  Clear
                                </a>
                              </div>
                            </dt>

                            <dd className="col-btn">
                              <a
                                id="cancel"
                                className="btn"
                                onClick={() => {
                                  pollingCancelled.current = true;
                                  clearExchangeBets();
                                }}
                              >
                                Cancel
                              </a>
                            </dd>

                            <dd id="oddsHeader" className="col-odd">
                              <ul className="quick-bet-confirm">
                                <li id="odds">{bet.oddValue.toFixed(2)}</li>
                                <li className="quick-bet-confirm-title">
                                  odds
                                </li>
                              </ul>
                            </dd>

                            <dd className="col-stake">
                              <NumberFormat
                                value={bet?.stakeAmount ? bet.stakeAmount : ""}
                                thousandSeparator={true}
                                thousandsGroupStyle="lakh"
                                className="row-input"
                                decimalScale={operatorId === "MPC1" ? 0 : 2}
                                allowNegative={false}
                                disabled={loading}
                                onValueChange={(val) => {
                                  setExchangeBetStake(
                                    index,
                                    val.floatValue ?? 0,
                                    "SET"
                                  );
                                }}
                              />
                            </dd>

                            <dd className="col-send" style={{ margin: "0px" }}>
                              <a
                                id="placeBet"
                                className={`btn-send disable ${setTextColor(
                                  getComputedStyle(document.body)
                                    .getPropertyValue("--primary")
                                )}`}
                                onClick={() => {
                                  placeBet(bet);
                                }}
                              >
                                Place Bet
                              </a>
                            </dd>

                            <dd
                              id="stakePopupList"
                              className="col-stake_list"
                              style={{ display: "block" }}
                            >
                              <ul>
                                {stakeAmountList.map(
                                  (stake: number, idx: number) => (
                                    <li key={`desktop-stake-${stake}-${idx}`}>
                                      <a
                                        className="btn"
                                        id={`bs_stake_${idx}`}
                                        style={{ cursor: "pointer" }}
                                        onClick={() =>
                                          setExchangeBetStake(
                                            0,
                                            stake,
                                            "ADD"
                                          )
                                        }
                                      >
                                        {stake}
                                      </a>
                                    </li>
                                  )
                                )}
                              </ul>

                              <p id="totalStakeP" style={{ display: "none" }}>
                                Total Stake: <strong id="totalStake" />
                              </p>
                            </dd>

                          </dl>
                        </div>
                      </div>
                    </div>
                </>
              </div>
            );
          })
        : null}
    </>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    userBalance: state.sportsBook.balance,
    bets: state.betslip.bets,
    oddsChanged: state.betslip.oddsChanged,
    betSuspended: state.betslip.betSuspended,
    betSlipMessage: state.betslip.message,
    currency: state.sportsBook.currency,
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    removeExchangeBet: (index: number) => dispatch(removeExchangeBet(index)),
    setExchangeBetStake: (index: number, amount: number, type: "ADD" | "SET") =>
      dispatch(setExchangeBetStake(index, amount, type)),
    clearExchangeBets: () => dispatch(clearExchcngeBets()),
    exchangeBetOddsChange: (index: number, odds: number) =>
      dispatch(exchangeBetOddsChange(index, odds)),
    fetchOpenBets: (eventId: string, sportId: string) =>
      dispatch(fetchOpenBets(eventId, sportId)),
    fetchBalance: () => dispatch(fetchBalance()),
    setBetSlipOddsChangeMsg: (flag: boolean) =>
      dispatch(setBetSlipOddsChangeMsg(flag)),
    acceptOddsChange: () => dispatch(acceptOddsChange()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PremiumFancyBetslip);
